var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('base-notification',{attrs:{"duration":20000,"group":"system","position":"bottom left"}}),_c('base-notification',{attrs:{"duration":5000,"group":"validation","position":"bottom right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }